import { numericFormatter } from "react-number-format";
import { columns } from "../../../../dtos/columns";
import Conversiones from "../../../../utils/conversiones";
import { EnumTipoEstadoRegistro, EstadoRegistro } from "../../../../utils/enums";
import { ValidadorMinvuDto } from "../models/validadorMinvu";
import { getDescriptionEstadoSubsidioMINVU } from "../../../contabilidad/validadorAsientos/utils/utils";


export function useColumns() {

    const COLUMNS: columns<ValidadorMinvuDto>[] = [
        {
            name: 'N° operación',
            selector: (row) =>
                row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },
        {
            name: 'Rut cliente',
            selector: (row) => row.rut,
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Cliente',
            selector: (row) =>
                `${row.apellidoPaternoDeudor} ${row.apellidoMaternoDeudor} ${row.nombresDeudor}`,
            sortable: true,
            sortField: 'nombresDeudor',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Fecha escritura',
            selector: (row) =>
                Conversiones.fechaCortaFormat(row.fechaEscritura?.toString() ?? ""),
            sortable: true,
            sortField: 'fechaEscritura',
            wrap: true,
            export: true,
        },
        {
            name: 'Monto crédito',
            selector: (row) =>
                row.monto,
            sortable: true,
            sortField: 'monto',
            wrap: true,
            export: true,
        },
        {
            name: 'Estado',
            selector: (row) =>
                getDescriptionEstadoSubsidioMINVU(row.estado),
             sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
        },
        {
            name: 'Beneficio',
            selector: (row) =>
                row.beneficio,
            sortable: true,
            sortField: 'beneficio',
            wrap: true,
            export: true,
        },

        {
            name: 'Porcentaje',
            selector: (row) =>
                !row.porcentaje ? "" : numericFormatter(row.porcentaje?.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "suffix": "%" }),
            sortable: true,
            sortField: 'porcentaje',
            wrap: true,
            export: true,
        },
    ]


    return { COLUMNS };
}